module.exports = __webpack_public_path__ + "img/132.c2900dce.jpg";